import * as BX from "main";
import {Reflection} from "main.core";
import {Overlay} from "citrus.aproduction3.overlay";

/**
 * @todo Избавиться от jquery
 * @todo Уменьшить зависимость от внутренней реализации других элементов шапки
 */
class HeaderSearch {
    constructor(containerSelector) {
        this.container = document.querySelector(containerSelector);
        if (!this.container) {
            return;
        }

        this.$container = $(this.container);
        this.$form = this.$container.find('.b-search__form');
        this.$searchInput = this.$container.find('.b-search__input');
        this.$searchButton = this.$container.find('.b-search__btnLink');

        this.clickOff(this.$container, e => {
            if (this.$container.has(e.target).length !== 0)
                return;

            this.collapse();
        });

        /* header search open */
        $(document).on('click', '.b-search__btnLink', e => {
            if (this.$container.has(e.target).length === 0)
                return;

            e.preventDefault();
            this.expand();
        });
    };

    expand() {
        this.$searchInput.focus();
        this.$form.animate({opacity: 1}, 50, () => {
            this.$searchButton.hide();
            this.$form.css('z-index', '2');
            this.$searchInput.animate({'max-width': '100%'}, 50, () => this.$container.addClass('b-search_opened'));

            // @todo Уменьшить связность
            $('.b-h__burger').removeClass('b-h__burger_active').css('z-index', '-1');
            $('.b-h__menuTop').css('z-index', '-1');
            $('body').removeClass('_menu');
            this.closeOverlay();
        });
    }

    closeOverlay() {
        const overlay = Overlay.getInstance();
        if (!overlay) {
            return;
        }
        overlay.hide(this);
    }

    collapse() {
        this.$container.removeClass('b-search_opened');
        this.$searchInput.animate({'max-width': 0}, 100, () => {
            this.$searchButton.show();

            // @todo Уменьшить связность
            $('.b-h__burger').css('z-index', '1');
            $('.b-h__menuTop').css('z-index', '1');
        });
        this.$form.animate({opacity: 0}, 100, () => this.$form.css('z-index', ''));
    }

    clickOff($el, callback) {
        if (!$el) return false;
        $(document).on('click', e => {
            if ($el.has(e.target).length === 0 && !$el.is(e.target)) {
                callback($el);
            }
        });
    }
}

const ns = Reflection.namespace('BX.Citrus.Aproduction3');
ns.HeaderSearch = HeaderSearch;
